<template>
  <picture
    :data-loaded="loaded"
  >
    <source
      :srcset="srcset.avif"
      :sizes="sizes"
      type="image/avif"
    >
    <source
      :srcset="srcset.webp"
      :sizes="sizes"
      type="image/webp"
    >

    <img
      :src="srcset.fallback"
      :alt="alt"
      :class="cssClass"
      :width="width"
      :height="height"
      :loading="lazyLoad ? 'lazy' : 'eager'"
      @load="loaded = true"
    >
  </picture>
</template>

<script setup>
import { computed, ref } from 'vue'

import { defaultImage, imageArray } from '@/assets/images/staticImages'

const props = defineProps({
  src: {
    type: String,
    required: true,
  },

  alt: {
    type: String,
    default: '',
  },

  imgClass: {
    type: String,
    default: 'embed-responsive-item image-cover',
  },

  height: {
    type: String,
    default: 'auto',
  },

  width: {
    type: String,
    default: 'auto',
  },

  sizes: {
    type: String,
    default: '(max-width: 575px) 100vw, (max-width: 991px) 50vw, 33.3vw',
  },

  lazyLoad: {
    type: Boolean,
    default: true,
  },
})

const srcset = computed(() => imageArray.find((image) => image.name === props.src) ?? defaultImage)

const loaded = ref(false)

const cssClass = computed(() => {
  return props.imgClass
})
</script>
